import makeStorage from './storage';

// Utilitário para gerenciar a competência selecionada no localStorage
const competenciaStorage = makeStorage('competencia_selecionada', 'localStorage', {});

export interface CompetenciaStorageData {
  sped_fiscal_id: number;
  competencia: string;
  data_inicio: string;
  data_fim: string;
}

export const CompetenciaStorageUtils = {
  // Salva competência no localStorage
  save: (data: CompetenciaStorageData) => {
    competenciaStorage.save(data);
  },

  // Recupera competência do localStorage
  get: (): CompetenciaStorageData | null => {
    const data = competenciaStorage.get();
    return data && data.sped_fiscal_id ? data : null;
  },

  // Remove competência do localStorage
  clear: () => {
    competenciaStorage.remove();
  }
};

export default CompetenciaStorageUtils; 